import React from 'react';
import moment from 'moment';

export default () => (
  <p>
    Copyright &copy; <a href="mailto:james@timing71.org">James Muscat</a> 2016-{ moment().format('YY') }. Feed data remains property of original data source.
  </p>
);
